<ng-container *ngIf="aiGlobalChatService.showGlobalAiChat$ | async as aiChatEvent">

  <ng-container *ngIf="aiChatEvent?.show">

    <div class="chat-container" [class.chat-container-sm]="isMinMAx">

      <div class="chat-sidebar" [class.hidden]="isSidebarHidden">
        <div class="new-btn-container d-flex align-items-center justify-content-between">
          <button (click)="restartChatSession()" class="btn-new-chat">
            <img [src]="newMsgIconUrl" alt="new message icon">
            <span>New Chat</span>
          </button>
          <button class="btn-close-sm" (click)="toggleSidebar()">
            <img [src]="closeIconUrl" alt="close icon">
          </button>
        </div>

        <div class="chat-log-wrapper">

          <div class="chat-log">
            <div class="user-log">

              <ng-container *ngIf="chatSummary24.length">
                <div class="log-span-tag">Today</div>
                <ul class="log-list" *ngFor="let summary of chatSummary24">
                  <li class="log-list-item" #listItem
                    (click)="getChatSessionDetail(summary.aiChatSessionId, listItem )">
                    <img [src]="logMsgIconUrl" alt="log message icon">
                    <div>
                      {{summary.sessionTitle}}
                      <span class="linear-gradient"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <ng-container *ngIf="chatSummary48.length">
                <div class="log-span-tag">Yesterday</div>
                <ul class="log-list" *ngFor="let summary of chatSummary48">
                  <li class="log-list-item" #listItem
                    (click)="getChatSessionDetail(summary.aiChatSessionId, listItem )">
                    <img [src]="logMsgIconUrl" alt="log message icon">
                    <div>
                      {{summary.sessionTitle}}
                      <span class="linear-gradient"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <ng-container *ngIf="chatSummary72.length">
                <div class="log-span-tag">Previous 3 Days</div>
                <ul class="log-list" *ngFor="let summary of chatSummary72">
                  <li class="log-list-item" #listItem
                    (click)="getChatSessionDetail(summary.aiChatSessionId, listItem )">
                    <img [src]="logMsgIconUrl" alt="log message icon">
                    <div>
                      {{summary.sessionTitle}}
                      <span class="linear-gradient"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <ng-container *ngIf="chatSummary168.length">
                <div class="log-span-tag">Previous 7 Days</div>
                <ul class="log-list" *ngFor="let summary of chatSummary168">
                  <li class="log-list-item" #listItem
                    (click)="getChatSessionDetail(summary.aiChatSessionId, listItem )">
                    <img [src]="logMsgIconUrl" alt="log message icon">
                    <div>
                      {{summary.sessionTitle}}
                      <span class="linear-gradient"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

              <ng-container *ngIf="chatSummary.length">
                <div class="log-span-tag">Older Than 30 Days</div>
                <ul class="log-list" *ngFor="let summary of chatSummary">
                  <li class="log-list-item">
                    <img [src]="logMsgIconUrl" alt="log message icon">
                    <div #listItem (click)="getChatSessionDetail(summary.aiChatSessionId, listItem )">
                      {{summary.sessionTitle}}
                      <span class="linear-gradient"></span>
                    </div>
                  </li>
                </ul>
              </ng-container>

            </div>

          </div>
        </div>
      </div>

      <div class="chat-window">
        <div class="chat-header d-flex align-items-center justify-content-between">
          <div class="chat-header-left">
            <button class="btn-toggle-sidebar" (click)="toggleSidebar()">
              <img [src]="sidebarIconUrl" alt="sidebar icon">
            </button>
          </div>
          <div class="chat-header-middle d-flex align-items-center">
            <img [src]="magicWandIconUrl" alt="magic wand icon">
            <h6>How can I help?</h6>
          </div>
          <div class="chat-header-right ">
            <button class="btn-min" (click)="toggleMin()">
              <img [src]="resizeMinIconUrl" alt="resize min icon">
            </button>
            <button class="btn-max" (click)="toggleMax()">
              <img [src]="resizeMaxIconUrl" alt="resize max icon">
            </button>
            <button class="btn-close" (click)="closeAiChat()">
              <img [src]="closeIconUrl" alt="close icon">
            </button>
          </div>

        </div>
        <div class="chat-body">

          <div class="empty-chat" *ngIf="!showMessages">
            <ng-container *ngIf="displayInitialMessage">
              <img [src]="emptyChatIconUrl" alt="empty chat icon">
              <h2>
                AI Course Creation Assistant
              </h2>
              <ng-container *ngIf="welcomeMessage">
                <p>{{welcomeMessage}}</p>
              </ng-container>

              <ng-container *ngIf="aiPromptId == 'defaultAssistant'">
                <p>Hi, I'm Owlie, your friendly AI Course Creation Assistant. How can I help you today?</p>

                <ul class="welcome-list">
                  <li>
                    ✅ I can give you suggestions for new content
                  </li>
                  <li>
                    ✅ I can improve your existing course content
                  </li>
                  <li>
                    ✅ Let me translate your course content
                  </li>
                  <li>
                    ✅ Let me help with spelling and grammar
                  </li>
                  <li>
                    ✅ Or I can advise on anything related to course creation
                  </li>

                </ul>

                <div class="btn-actions" (click)="aiLearnMore()">
                  <button class="btn-admin-primary">
                    <span class="material-symbols-outlined">
                      help
                    </span>
                    <span> Learn More</span>
                  </button>
                </div>
              </ng-container>

            </ng-container>

            <!--div class="loading" *ngIf="isAiLoading">
              <img class="loading-chat" [src]="loadingGifUrl" alt="">
            </div-->

          </div>

          <div class="message-box" *ngIf="showMessages" #messageContainer>
            <div class="messages-container">

              <div *ngFor="let chat of chatHistory; let i = index" class="messages">
                <div *ngIf="chat.role =='assistant'" class="msg-receiver-wrapper">
                  <div class="receiver-img">
                    <img [src]="receiverImgUrl" alt="receiver image">
                  </div>
                  <div class="msg-receiver">
                    <ul>
                      <li>
                        <span [innerHTML]="insertLineBreaks(chat.content) | safeHtml"></span>
<!--                        <img (click)="copyToClipboard(chat.content)" [src]="copyIconUrl" alt="copy icon">-->
                      </li>
                    </ul>
                    <img class="receive-curve" [src]="receiveCurveImgUrl" alt="receive curve">
                  </div>
                </div>

                <div *ngIf="chat.role=='user'" class="msg-sender-wrapper">
                  <div class="msg-sender">
                    <section class="user-msg">
                      <span [innerHTML]="insertLineBreaks(chat.content) | safeHtml"></span>
                      <ng-container
                        *ngIf="i === chatHistory.length - 2 && !isAiLoading">
                        <span class="btn-retry material-symbols-outlined" (click)="callGptApi(true)">replay</span>
                      </ng-container>
                    </section>
                    <img class="sender-curve" [src]="sendCurveImgUrl" alt="">
                  </div>
                  <div class="sender-img">
                    <img [src]="tenantPictureUrl" alt="">
                  </div>
                </div>

              </div>

              <div class="messages">
                <div *ngIf="isAiLoading && messageFromUser" class="msg-sender-wrapper">
                  <div class="msg-sender">
                    <span [innerHTML]="insertLineBreaks(messageFromUser) | safeHtml"></span>
                    <img class="sender-curve" [src]="sendCurveImgUrl" alt="">
                  </div>
                  <div class="sender-img">
                    <img [src]="tenantPictureUrl" alt="">
                  </div>
                </div>
              </div>

              <div class="loading" *ngIf="isAiLoading">
                <img [src]="loadingGifUrl" alt="loading gif">
                <p *ngIf="countdown >= 2">It can take up to 60 seconds to get a reply. <strong>{{ countdown }}</strong>
                  seconds ...</p>
              </div>
            </div>
          </div>
        </div>

        <div class="chat-footer">
          <div class="message-input-box">
            <div class="message-input">
              <form>
                <input name="defaultInputValue" [(ngModel)]="inputValue" type="text" id="chatInput">
                <button [disabled]="isAiLoading && messageFromUser !== ''" (click)="callGptApi(false)">
                  <img [src]="sendIconImgUrl" alt="send icon image">
                </button>
              </form>
            </div>
            <div class="user-img">
              <img [src]="tenantPictureUrl" alt="tenant picture">
            </div>
          </div>
          <div class="warning-msg d-flex align-items-start justify-content-center">
            <img [src]="warningIconUrl" alt="warning icon">
            <span>To get the best results, give our AI as much context as possible. If an error occurs, please try
              again after a few seconds.</span>
          </div>

        </div>
      </div>
    </div>

  </ng-container>

</ng-container>
